/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { GetTaskCountsRead } from './getTaskCountsRead';

export type GetTaskCountsParams = {
/**
 * Active project scope (required).
 */
project_id: string;
read?: GetTaskCountsRead;
types?: string[] | null;
priorities?: string[] | null;
jobs?: string[] | null;
jobs_excluded?: string[] | null;
sequences?: string[] | null;
sequences_excluded?: string[] | null;
candidates?: string[] | null;
candidates_excluded?: string[] | null;
assignees?: string[] | null;
assignees_excluded?: string[] | null;
due_from?: string | null;
due_to?: string | null;
q?: string | null;
job_id?: string | null;
sequence_id?: string | null;
};
